const exportModalCalendar = {
  exportData: 'Exportar Dados',
  excel: 'PLANILHA(.XLSX)',
};

export default exportModalCalendar;
